/**
 * Checkout/Cart URL Interceptor
 * Intercepts clicks on links containing /checkout or /cart/
 * and adds skip_shop_pay=true query parameter to the URL
 */
(function() {
  'use strict';

  /**
   * Check if a URL contains /checkout or /cart/ (with trailing slash only)
   * @param {string} url - URL to check
   * @returns {boolean}
   */
  function containsBlockedPath(url) {
    if (!url) return false;
    
    try {
      // Handle both absolute and relative URLs
      const urlObj = url.startsWith('http') ? new URL(url) : new URL(url, window.location.origin);
      const pathname = urlObj.pathname;
      
      // Check for /checkout (any variation) or /cart/ (must have trailing slash)
      const hasCheckout = pathname.includes('/checkout');
      // Only match /cart/ with trailing slash, not /cart without it
      const hasCart = pathname.includes('/cart/') && pathname !== '/cart';
      
      return hasCheckout || hasCart;
    } catch (e) {
      // Fallback to string check if URL parsing fails
      // Only match /cart/ with trailing slash, not /cart without it
      return (url.includes('/checkout') || (url.includes('/cart/') && !url.match(/\/cart[^\/]/)));
    }
  }

  /**
   * Add skip_shop_pay=true query parameter to a URL
   * If URL already has query params, adds with &, otherwise adds with ?
   * @param {string} url - URL to modify
   * @returns {string} - Modified URL with query parameter
   */
  function addSkipShopPayParam(url) {
    if (!url) return url;
    
    try {
      // Handle both absolute and relative URLs
      const urlObj = url.startsWith('http') ? new URL(url) : new URL(url, window.location.origin);
      
      // Check if skip_shop_pay already exists
      if (urlObj.searchParams.has('skip_shop_pay')) {
        // Already exists, just return the URL as is
        return urlObj.toString();
      }
      
      // Add the parameter
      urlObj.searchParams.set('skip_shop_pay', 'true');
      
      // Return the modified URL
      // If original was relative, return relative; if absolute, return absolute
      if (url.startsWith('http')) {
        return urlObj.toString();
      } else {
        return urlObj.pathname + urlObj.search + (urlObj.hash || '');
      }
    } catch (e) {
      // Fallback: simple string manipulation
      // Check if URL already has query parameters
      const hasQuery = url.includes('?');
      const separator = hasQuery ? '&' : '?';
      
      // Check if parameter already exists
      if (url.includes('skip_shop_pay=')) {
        return url;
      }
      
      return url + separator + 'skip_shop_pay=true';
    }
  }

  /**
   * Handle link click - check if URL contains blocked path and add skip param
   * @param {Event} e - Click event
   * @param {HTMLAnchorElement} anchor - Anchor element that was clicked
   */
  function handleLinkClick(e, anchor) {
    const href = anchor.getAttribute('href');
    
    if (href && containsBlockedPath(href)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const modifiedUrl = addSkipShopPayParam(href);
      window.location.href = modifiedUrl;
      
      return false;
    }
  }

  /**
   * Intercept link clicks
   */
  document.body.addEventListener('click', function(e) {
    const anchor = e.target.closest('a[href]');
    if (anchor) {
      handleLinkClick(e, anchor);
    }
  });
})();
